import { BaseActionEnum } from "../../../components/action-menu/ActionMenuItem";
import { IeLynxObject } from "../eLynxObject";

const OBJECT_CHANGED_TOPIC = 'OBJECT_CHANGED';
const OFFLINE_PENDING_CHANGES_SAVED_TOPIC = 'OFFLINE_PENDING_CHANGES_SAVED';
const CONFIGURATION_CHANGED_TOPIC = 'CONFIGURATION_CHANGED_TOPIC';
const CONFIGURATION_RESET_TOPIC = 'CONFIGURATION_RESET_TOPIC';
const EXECUTE_ACTION_TOPIC = 'EXECUTE_ACTION_TOPIC';

export {OBJECT_CHANGED_TOPIC,
    OFFLINE_PENDING_CHANGES_SAVED_TOPIC,
    CONFIGURATION_CHANGED_TOPIC,
    CONFIGURATION_RESET_TOPIC,
    EXECUTE_ACTION_TOPIC
};

export type ObjectChangedMsg = {
    entity: IeLynxObject;

    name?: string;
    disabled?: boolean;
    visible?: boolean;
}

export type OfflineChangesMsg = {
    customerID: number
}

export type ConfigurationChangedMsg = {
    configurationID: number
}

export type ExecuteActionMsg = {
    action: BaseActionEnum;
}